import { useI18n } from '../../i18n'
import { pressureColor } from '../../utils/operationalUx'
import styles from '../../styles/components/assets/AssetsInventoryIntelligence.module.scss'

type Props = {
  exposureLevel?: string | null
  internetFacing?: boolean
  degraded?: boolean
  staleEvidence?: boolean
  runtimeWarning?: boolean
  assuranceLevel?: string | null
  compact?: boolean
}

export default function AssetInventoryOperationalIndicators({
  exposureLevel,
  internetFacing,
  degraded,
  staleEvidence,
  runtimeWarning,
  assuranceLevel,
  compact,
}: Props) {
  const { t } = useI18n()
  const wrap = compact ? styles.aiIndicatorRowCompact : styles.aiIndicatorRow

  return (
    <div className={wrap}>
      {internetFacing ? (
        <span className={`${styles.aiIndicatorChip} ${styles.aiIndicatorInternet}`} title={t('enterpriseOperationalUx.assetInventory.internetFacing', 'Internet-facing')}>
          {t('enterpriseOperationalUx.assetInventory.internetShort', 'exposed')}
        </span>
      ) : null}
      {exposureLevel && exposureLevel !== 'LOW' ? (
        <span
          className={`${styles.aiIndicatorChip} ${styles.aiIndicatorExposure}`}
          style={{ color: pressureColor(exposureLevel), borderColor: pressureColor(exposureLevel) }}
          title={t('enterpriseOperationalUx.assetInventory.operationalExposure', 'Operational exposure')}
        >
          {exposureLevel}
        </span>
      ) : null}
      {degraded ? (
        <span className={`${styles.aiIndicatorChip} ${styles.aiIndicatorDegraded}`} title={t('enterpriseOperationalUx.assetInventory.runtimeDegradation', 'Runtime degradation')}>
          {t('enterpriseOperationalUx.degradedShort', 'degraded')}
        </span>
      ) : null}
      {staleEvidence ? (
        <span className={`${styles.aiIndicatorChip} ${styles.aiIndicatorStale}`} title={t('enterpriseOperationalUx.staleEvidence', 'Stale evidence')}>
          {t('enterpriseOperationalUx.assetInventory.staleShort', 'stale')}
        </span>
      ) : null}
      {assuranceLevel === 'MANUAL' ? (
        <span className={`${styles.aiIndicatorChip} ${styles.aiIndicatorManual}`} title={t('enterpriseOperationalUx.assetInventory.continuousAssurance', 'Continuous assurance')}>
          {t('enterpriseOperationalUx.assetInventory.manualAssurance', 'manual')}
        </span>
      ) : null}
      {assuranceLevel === 'CONTINUOUS' ? (
        <span className={`${styles.aiIndicatorChip} ${styles.aiIndicatorContinuous}`} title={t('enterpriseOperationalUx.assetInventory.continuousAssurance', 'Continuous assurance')}>
          {t('enterpriseOperationalUx.assetInventory.continuousShort', 'continuous')}
        </span>
      ) : null}
      {runtimeWarning ? <span className={styles.aiRuntimeDot} aria-hidden /> : null}
    </div>
  )
}
